import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'

const RightButton = styled(Button)(({ theme }) => ({
  fontSize: 16,
  fontWeight: 900,
  color: theme.palette.primary.contrastText,
  paddingLeft: '5px',
  '&:hover': {
    color: theme.palette.grey[50]
  }
}))

const AllRequestsBtn: React.FC = () => {
  return (
    <RightButton
      startIcon={<ArrowBackIosNewIcon sx={{ width: 10 }} />}
    >
      All Requests
    </RightButton>
  )
}

export default AllRequestsBtn
